import type { FilmTitle } from "@/types/film";

export const movies: FilmTitle[] = [
  {
    id: "m-01",
    title: "肖申克的救赎",
    originalTitle: "The Shawshank Redemption",
    type: "movie",
    year: 1994,
    genres: ["剧情", "犯罪"],
    region: "美国",
    language: "英语",
    rating: 9.7,
    popularity: 992,
    duration: "142 分钟",
    director: "弗兰克·德拉邦特",
    cast: ["蒂姆·罗宾斯", "摩根·弗里曼", "鲍勃·冈顿"],
    synopsis:
      "银行家安迪被误判入狱，在肖申克监狱的高墙内，他用二十年的耐心与智慧守护着希望，也悄悄改写了自己与狱友的命运。这是一部关于自由、友谊与坚持的经典之作。",
    tags: ["经典", "高分", "奥斯卡"],
    awards: ["10 项奥斯卡金像奖提名"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20minimal%20movie%20poster%20art%20of%20a%20lone%20man%20in%20a%20prison%20courtyard%20under%20warm%20golden%20sunlight%2C%20rain%20and%20stone%20walls%2C%20dramatic%20silhouette%2C%20deep%20blue%20shadows%2C%20film%20grain%2C%20fine%20art%20texture&width=480&height=640&seq=mv-01&orientation=portrait",
  },
  {
    id: "m-02",
    title: "星际穿越",
    originalTitle: "Interstellar",
    type: "movie",
    year: 2014,
    genres: ["科幻", "冒险", "剧情"],
    region: "美国",
    language: "英语",
    rating: 9.4,
    popularity: 968,
    duration: "169 分钟",
    director: "克里斯托弗·诺兰",
    cast: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    synopsis:
      "当地球濒临枯竭，一群宇航员穿越虫洞寻找人类新家园。在浩瀚宇宙与时间扭曲之间，父女之间的牵挂成为跨越光年的力量。",
    tags: ["经典", "高分", "热播"],
    awards: ["第 87 届奥斯卡最佳视觉效果奖"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20poster%20art%20of%20an%20astronaut%20silhouette%20before%20a%20giant%20glowing%20planet%20and%20wormhole%2C%20deep%20blue%20and%20warm%20amber%20light%2C%20star%20field%2C%20epic%20minimal%20composition&width=480&height=640&seq=mv-02&orientation=portrait",
  },
  {
    id: "m-03",
    title: "盗梦空间",
    originalTitle: "Inception",
    type: "movie",
    year: 2010,
    genres: ["科幻", "悬疑", "动作"],
    region: "美国",
    language: "英语",
    rating: 9.4,
    popularity: 951,
    duration: "148 分钟",
    director: "克里斯托弗·诺兰",
    cast: ["莱昂纳多·迪卡普里奥", "约瑟夫·高登-莱维特", "艾伦·佩吉"],
    synopsis:
      "一支潜入梦境的团队受雇在目标的潜意识中植入意念。层层嵌套的梦境里，真实与幻觉的边界不断坍塌，回家的执念成为唯一坐标。",
    tags: ["经典", "高分", "热播"],
    awards: ["第 83 届奥斯卡最佳摄影等 4 项大奖"],
    cover:
      "https://readdy.ai/api/search-image?query=surreal%20cinematic%20poster%20art%20of%20a%20city%20folding%20onto%20itself%20above%20a%20reflective%20wet%20street%2C%20man%20in%20a%20suit%20standing%20in%20distance%2C%20cool%20blue%20tones%2C%20dramatic%20light&width=480&height=640&seq=mv-03&orientation=portrait",
  },
  {
    id: "m-04",
    title: "教父",
    originalTitle: "The Godfather",
    type: "movie",
    year: 1972,
    genres: ["剧情", "犯罪"],
    region: "美国",
    language: "英语",
    rating: 9.3,
    popularity: 902,
    duration: "175 分钟",
    director: "弗朗西斯·福特·科波拉",
    cast: ["马龙·白兰度", "阿尔·帕西诺", "詹姆斯·肯恩"],
    synopsis:
      "纽约黑手党家族的权力交接史诗。老教父维托的隐忍与智慧，小儿子迈克尔的蜕变与孤独，共同构成了一部关于家族、忠诚与代价的传世经典。",
    tags: ["经典", "高分", "奥斯卡"],
    awards: ["第 45 届奥斯卡最佳影片"],
    cover:
      "https://readdy.ai/api/search-image?query=classic%20noir%20movie%20poster%20art%20of%20an%20elegant%20aging%20mafia%20boss%20in%20a%20tuxedo%20sitting%20in%20shadow%2C%20warm%20amber%20rim%20light%2C%20deep%20black%20background%2C%20vintage%20film%20texture&width=480&height=640&seq=mv-04&orientation=portrait",
  },
  {
    id: "m-05",
    title: "阿甘正传",
    originalTitle: "Forrest Gump",
    type: "movie",
    year: 1994,
    genres: ["剧情", "爱情"],
    region: "美国",
    language: "英语",
    rating: 9.5,
    popularity: 934,
    duration: "142 分钟",
    director: "罗伯特·泽米吉斯",
    cast: ["汤姆·汉克斯", "罗宾·怀特", "加里·西尼斯"],
    synopsis:
      "智商不高却心地纯粹的阿甘，用一路奔跑穿越大半个美国近代史。他用最简单的坚持，回应了命运抛出的所有难题。",
    tags: ["经典", "高分", "奥斯卡"],
    awards: ["第 67 届奥斯卡最佳影片等 6 项大奖"],
    cover:
      "https://readdy.ai/api/search-image?query=warm%20nostalgic%20movie%20poster%20art%20of%20a%20man%20running%20along%20a%20long%20empty%20country%20road%20at%20golden%20sunset%2C%20white%20feather%20floating%20in%20sky%2C%20soft%20sepia%20tones&width=480&height=640&seq=mv-05&orientation=portrait",
  },
  {
    id: "m-06",
    title: "辛德勒的名单",
    originalTitle: "Schindler's List",
    type: "movie",
    year: 1993,
    genres: ["剧情", "历史", "战争"],
    region: "美国",
    language: "英语",
    rating: 9.5,
    popularity: 887,
    duration: "195 分钟",
    director: "史蒂文·斯皮尔伯格",
    cast: ["连姆·尼森", "本·金斯利", "拉尔夫·费因斯"],
    synopsis:
      "二战期间，德国商人辛德勒用工厂名单挽救了上千名犹太人。黑白影像中那抹红色，成为人性微光最沉重的注脚。",
    tags: ["经典", "高分", "奥斯卡"],
    awards: ["第 66 届奥斯卡最佳影片等 7 项大奖"],
    cover:
      "https://readdy.ai/api/search-image?query=black%20and%20white%20historical%20drama%20poster%20art%20of%20a%20small%20girl%20in%20a%20red%20coat%20walking%20through%20a%20crowded%20wartime%20street%2C%20desaturated%20tones%2C%20single%20red%20accent%2C%20solemn%20mood&width=480&height=640&seq=mv-06&orientation=portrait",
  },
  {
    id: "m-07",
    title: "这个杀手不太冷",
    originalTitle: "Léon",
    type: "movie",
    year: 1994,
    genres: ["剧情", "动作", "犯罪"],
    region: "法国",
    language: "英语",
    rating: 9.4,
    popularity: 856,
    duration: "110 分钟",
    director: "吕克·贝松",
    cast: ["让·雷诺", "娜塔莉·波特曼", "加里·奥德曼"],
    synopsis:
      "沉默的杀手与失去家人的少女结成奇特的伙伴。冰冷的职业与温暖的情感相互碰撞，绿植成为两人唯一想守护的柔软。",
    tags: ["经典", "高分"],
    awards: ["法国凯撒奖多项提名"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20a%20tall%20silent%20man%20in%20a%20long%20coat%20and%20a%20young%20girl%20holding%20a%20potted%20plant%20in%20a%20dim%20doorway%2C%20warm%20amber%20light%2C%20cool%20blue%20shadows%2C%20urban%20night&width=480&height=640&seq=mv-07&orientation=portrait",
  },
  {
    id: "m-08",
    title: "泰坦尼克号",
    originalTitle: "Titanic",
    type: "movie",
    year: 1997,
    genres: ["剧情", "爱情"],
    region: "美国",
    language: "英语",
    rating: 9.5,
    popularity: 913,
    duration: "194 分钟",
    director: "詹姆斯·卡梅隆",
    cast: ["莱昂纳多·迪卡普里奥", "凯特·温丝莱特", "比利·赞恩"],
    synopsis:
      "首航的巨轮上，一段跨越阶层的爱情在冰山撞击的夜晚被永远铭记。冰冷海水中的那句承诺，成为影史最动人的回响。",
    tags: ["经典", "高分", "奥斯卡"],
    awards: ["第 70 届奥斯卡最佳影片等 11 项大奖"],
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20cinematic%20poster%20art%20of%20a%20couple%20embracing%20at%20the%20bow%20of%20a%20grand%20ocean%20liner%20at%20dusk%2C%20warm%20sunset%20glow%20over%20dark%20blue%20sea%2C%20epic%20scale&width=480&height=640&seq=mv-08&orientation=portrait",
  },
  {
    id: "m-09",
    title: "楚门的世界",
    originalTitle: "The Truman Show",
    type: "movie",
    year: 1998,
    genres: ["剧情", "科幻"],
    region: "美国",
    language: "英语",
    rating: 9.4,
    popularity: 842,
    duration: "103 分钟",
    director: "彼得·威尔",
    cast: ["金·凯瑞", "劳拉·琳妮", "艾德·哈里斯"],
    synopsis:
      "楚门生活在一座完美的小镇，直到他发现天空可能只是一块幕布。当整个世界都是一场秀，走出去需要多大的勇气？",
    tags: ["经典", "高分"],
    awards: ["第 71 届奥斯卡最佳原创剧本提名"],
    cover:
      "https://readdy.ai/api/search-image?query=conceptual%20cinematic%20poster%20art%20of%20a%20suburban%20house%20facade%20opening%20like%20a%20stage%20with%20a%20painted%20sky%20behind%20it%2C%20a%20man%20sailing%20a%20small%20boat%2C%20bright%20blue%20sky%2C%20clean%20minimal%20style&width=480&height=640&seq=mv-09&orientation=portrait",
  },
  {
    id: "m-10",
    title: "蝙蝠侠：黑暗骑士",
    originalTitle: "The Dark Knight",
    type: "movie",
    year: 2008,
    genres: ["动作", "犯罪", "惊悚"],
    region: "美国",
    language: "英语",
    rating: 9.2,
    popularity: 899,
    duration: "152 分钟",
    director: "克里斯托弗·诺兰",
    cast: ["克里斯蒂安·贝尔", "希斯·莱杰", "艾伦·艾克哈特"],
    synopsis:
      "小丑的疯狂让哥谭陷入混乱。当正义与非正义的界限被刻意模糊，蝙蝠侠必须在光明与黑暗之间做出最艰难的选择。",
    tags: ["经典", "高分", "热播"],
    awards: ["第 81 届奥斯卡最佳男配角奖"],
    cover:
      "https://readdy.ai/api/search-image?query=dark%20gritty%20superhero%20poster%20art%20of%20a%20caped%20figure%20standing%20on%20a%20rainy%20skyscraper%20rooftop%20at%20night%2C%20city%20lights%20below%2C%20deep%20blue%20and%20black%20tones%2C%20dramatic%20contrast&width=480&height=640&seq=mv-10&orientation=portrait",
  },
  {
    id: "m-11",
    title: "指环王：王者无敌",
    originalTitle: "The Lord of the Rings: The Return of the King",
    type: "movie",
    year: 2003,
    genres: ["奇幻", "冒险", "剧情"],
    region: "新西兰",
    language: "英语",
    rating: 9.3,
    popularity: 878,
    duration: "201 分钟",
    director: "彼得·杰克逊",
    cast: ["伊利亚·伍德", "维果·莫腾森", "西恩·奥斯汀"],
    synopsis:
      "中土世界的最终一战。魔戒被投入末日火山的瞬间，友谊、牺牲与归乡的史诗画上句点。宏大场面与细腻情感交织。",
    tags: ["经典", "高分", "奥斯卡"],
    awards: ["第 76 届奥斯卡 11 项大奖全获"],
    cover:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20poster%20art%20of%20a%20small%20hero%20holding%20a%20glowing%20golden%20ring%20before%20a%20lava%20volcano%20and%20great%20army%2C%20runic%20firelight%2C%20warm%20orange%20and%20deep%20blue%2C%20grand%20scale&width=480&height=640&seq=mv-11&orientation=portrait",
  },
  {
    id: "m-12",
    title: "搏击俱乐部",
    originalTitle: "Fight Club",
    type: "movie",
    year: 1999,
    genres: ["剧情", "悬疑", "惊悚"],
    region: "美国",
    language: "英语",
    rating: 9.0,
    popularity: 861,
    duration: "139 分钟",
    director: "大卫·芬奇",
    cast: ["布拉德·皮特", "爱德华·诺顿", "海伦娜·伯翰·卡特"],
    synopsis:
      "失眠的白领与狂放的地下拳手共同创立搏击俱乐部。当规则不断失控，他终于发现，真正的敌人其实来自自己。",
    tags: ["经典", "高分"],
    awards: ["第 72 届奥斯卡最佳音效剪辑提名"],
    cover:
      "https://readdy.ai/api/search-image?query=grungy%20cinematic%20poster%20art%20of%20two%20men%20in%20a%20dim%20underground%20fight%20club%20facing%20each%20other%20in%20harsh%20spotlight%2C%20concrete%20walls%2C%20smoke%2C%20desaturated%20cold%20tones&width=480&height=640&seq=mv-12&orientation=portrait",
  },
  {
    id: "m-13",
    title: "当幸福来敲门",
    originalTitle: "The Pursuit of Happyness",
    type: "movie",
    year: 2006,
    genres: ["剧情", "传记"],
    region: "美国",
    language: "英语",
    rating: 9.2,
    popularity: 828,
    duration: "117 分钟",
    director: "加布里尔·穆奇诺",
    cast: ["威尔·史密斯", "贾登·史密斯", "坦迪·牛顿"],
    synopsis:
      "落魄的单身父亲带着儿子在旧金山艰难求生，从地铁站厕所到实习工位，他始终没有放下对更好生活的追求。",
    tags: ["高分", "经典"],
    awards: ["第 79 届奥斯卡最佳男主角提名"],
    cover:
      "https://readdy.ai/api/search-image?query=warm%20emotional%20drama%20poster%20art%20of%20a%20father%20and%20young%20son%20walking%20hand%20in%20hand%20down%20a%20busy%20city%20street%20at%20golden%20hour%2C%20hopeful%20uplifting%20mood%2C%20soft%20amber%20light&width=480&height=640&seq=mv-13&orientation=portrait",
  },
  {
    id: "m-14",
    title: "疯狂动物城",
    originalTitle: "Zootopia",
    type: "movie",
    year: 2016,
    genres: ["动画", "喜剧", "冒险"],
    region: "美国",
    language: "英语",
    rating: 9.2,
    popularity: 874,
    duration: "109 分钟",
    director: "拜伦·霍华德",
    cast: ["金妮弗·古德温", "杰森·贝特曼", "伊德里斯·艾尔巴"],
    synopsis:
      "来自乡村的兔子警官与狡黠的狐狸搭档，在繁华的动物都市里联手破案。童话外衣之下，藏着关于偏见与勇气的温柔寓言。",
    tags: ["热播", "高分", "奥斯卡"],
    awards: ["第 89 届奥斯卡最佳动画长片奖"],
    cover:
      "https://readdy.ai/api/search-image?query=bright%20playful%20animation%20poster%20art%20of%20a%20cheerful%20cartoon%20rabbit%20police%20officer%20and%20a%20sly%20cartoon%20fox%20standing%20in%20a%20colorful%20modern%20city%20street%2C%20vivid%20clean%20illustration&width=480&height=640&seq=mv-14&orientation=portrait",
  },
  {
    id: "m-15",
    title: "绿皮书",
    originalTitle: "Green Book",
    type: "movie",
    year: 2018,
    genres: ["剧情", "喜剧", "传记"],
    region: "美国",
    language: "英语",
    rating: 8.9,
    popularity: 806,
    duration: "130 分钟",
    director: "彼得·法雷里",
    cast: ["维果·莫腾森", "马赫沙拉·阿里", "琳达·卡德里尼"],
    synopsis:
      "一位意大利裔司机护送黑人钢琴家深入种族隔离的南方巡演。一趟公路旅程，让两个截然不同的人学会了彼此理解。",
    tags: ["高分", "奥斯卡", "经典"],
    awards: ["第 91 届奥斯卡最佳影片奖"],
    cover:
      "https://readdy.ai/api/search-image?query=warm%20road%20trip%20poster%20art%20of%20a%20vintage%20turquoise%20car%20driving%20down%20a%20sunny%20country%20highway%2C%20two%20men%20in%20front%20seat%2C%20nostalgic%20amber%20tones%2C%20cinematic&width=480&height=640&seq=mv-15&orientation=portrait",
  },
  {
    id: "m-16",
    title: "波西米亚狂想曲",
    originalTitle: "Bohemian Rhapsody",
    type: "movie",
    year: 2018,
    genres: ["剧情", "音乐", "传记"],
    region: "英国",
    language: "英语",
    rating: 8.7,
    popularity: 793,
    duration: "134 分钟",
    director: "布莱恩·辛格",
    cast: ["拉米·马雷克", "露西·宝通", "格威利姆·李"],
    synopsis:
      "皇后乐队与主唱弗雷迪·默丘里的传奇旅程。舞台上的万丈光芒与舞台下的孤独挣扎，最终汇成那场震撼世界的演出。",
    tags: ["高分", "热播", "奥斯卡"],
    awards: ["第 91 届奥斯卡最佳男主角等 4 项大奖"],
    cover:
      "https://readdy.ai/api/search-image?query=glam%20rock%20concert%20poster%20art%20of%20a%20charismatic%20singer%20in%20a%20yellow%20jacket%20on%20stage%20with%20arms%20raised%20under%20purple%20spotlights%2C%20microphone%20stand%2C%20energetic%20crowd&width=480&height=640&seq=mv-16&orientation=portrait",
  },
  {
    id: "m-17",
    title: "小丑",
    originalTitle: "Joker",
    type: "movie",
    year: 2019,
    genres: ["剧情", "犯罪", "惊悚"],
    region: "美国",
    language: "英语",
    rating: 8.7,
    popularity: 837,
    duration: "122 分钟",
    director: "托德·菲利普斯",
    cast: ["华金·菲尼克斯", "罗伯特·德尼罗", "莎姬·贝兹"],
    synopsis:
      "一个被城市遗忘的喜剧演员，在冷漠与暴力中一步步滑向深渊。他的笑声里，藏着整个时代的失序与孤独。",
    tags: ["高分", "热播"],
    awards: ["第 92 届奥斯卡最佳男主角奖"],
    cover:
      "https://readdy.ai/api/search-image?query=moody%20cinematic%20poster%20art%20of%20a%20clown%20with%20green%20hair%20looking%20up%20in%20a%20damp%20city%20alley%2C%20cold%20teal%20shadows%20and%20faint%20amber%20light%2C%20melancholic%20urban%20mood&width=480&height=640&seq=mv-17&orientation=portrait",
  },
  {
    id: "m-18",
    title: "怦然心动",
    originalTitle: "Flipped",
    type: "movie",
    year: 2010,
    genres: ["剧情", "爱情", "青春"],
    region: "美国",
    language: "英语",
    rating: 9.1,
    popularity: 774,
    duration: "90 分钟",
    director: "罗伯·莱纳",
    cast: ["玛德琳·卡罗尔", "卡兰·麦克奥利菲", "瑞贝卡·德·莫妮"],
    synopsis:
      "一棵梧桐树、两条成长轨迹，男孩与女孩在年少的误会与心动之间慢慢靠近。青春里最清澈的喜欢，被拍得闪闪发亮。",
    tags: ["高分", "经典"],
    awards: ["影迷票选高分青春片"],
    cover:
      "https://readdy.ai/api/search-image?query=soft%20nostalgic%20coming%20of%20age%20poster%20art%20of%20two%20teenagers%20sitting%20side%20by%20side%20on%20a%20branch%20of%20a%20tall%20sycamore%20tree%2C%20bright%20blue%20sky%2C%20warm%20sunlight%2C%20gentle%20pastel%20tones&width=480&height=640&seq=mv-18&orientation=portrait",
  },
  {
    id: "m-19",
    title: "血战钢锯岭",
    originalTitle: "Hacksaw Ridge",
    type: "movie",
    year: 2016,
    genres: ["剧情", "战争", "传记"],
    region: "美国",
    language: "英语",
    rating: 8.7,
    popularity: 758,
    duration: "139 分钟",
    director: "梅尔·吉布森",
    cast: ["安德鲁·加菲尔德", "萨姆·沃辛顿", "文斯·沃恩"],
    synopsis:
      "坚守信仰拒绝持枪的军医戴斯蒙德，在冲绳战场上徒手救回数十名伤员。真实事件改编，勇气与信念在硝烟中闪光。",
    tags: ["高分", "经典"],
    awards: ["第 89 届奥斯卡最佳剪辑等 2 项大奖"],
    cover:
      "https://readdy.ai/api/search-image?query=intense%20war%20drama%20poster%20art%20of%20a%20medic%20crouching%20on%20a%20rocky%20cliff%20at%20dawn%20lowering%20a%20wounded%20soldier%20with%20ropes%2C%20smoke%20and%20grey%20sky%2C%20grim%20determined%20mood&width=480&height=640&seq=mv-19&orientation=portrait",
  },
  {
    id: "m-20",
    title: "爱乐之城",
    originalTitle: "La La Land",
    type: "movie",
    year: 2016,
    genres: ["剧情", "爱情", "音乐"],
    region: "美国",
    language: "英语",
    rating: 8.9,
    popularity: 789,
    duration: "128 分钟",
    director: "达米恩·查泽雷",
    cast: ["瑞恩·高斯林", "艾玛·斯通", "约翰·传奇"],
    synopsis:
      "在洛杉矶追梦的爵士钢琴师与女演员相遇相爱。聚光灯与现实的拉扯之间，梦想与爱情能否同时抵达？",
    tags: ["高分", "热播", "奥斯卡"],
    awards: ["第 89 届奥斯卡最佳导演等 6 项大奖"],
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20musical%20poster%20art%20of%20a%20couple%20dancing%20under%20a%20starry%20purple%20blue%20sky%20in%20los%20angeles%2C%20city%20lights%20and%20freeway%2C%20dreamy%20nostalgic%20candy%20colors&width=480&height=640&seq=mv-20&orientation=portrait",
  },
];